module.exports = __webpack_public_path__ + "img/bg_content_22.6f9ff141.png";